import { jsx as _jsx } from "react/jsx-runtime";
import RatePlanDetailComponent from '@/components/rateplans/RatePlanDetail';
var RatePlanDetail = function () {
    return _jsx(RatePlanDetailComponent, {});
};
export default RatePlanDetail;
